<form [formGroup]="nameForm">
  <rt-input
    type="text"
    formControlName="name"
    [autoFocus]="true"
    (keyup.enter)="save()"
    (keyup.esc)="cancel()"
  >
  </rt-input>
</form>
<div class="form-actions">
  <rt-group>
    <rt-button
      [loading]="processing"
      (click)="save()"
      [disabled]="!nameForm.valid || nameForm.get('name')!.value === value"
      variant="primary small"
    >
      {{ 'rtu.common.save' | translate }}
    </rt-button>
    <rt-button variant="plain small" (click)="cancel()">
      {{ 'rtu.common.cancel' | translate }}
    </rt-button>
  </rt-group>
</div>
